import { Message } from 'element-ui';
import innerHTML from '@/utils/innerHTML.js';
const mixins = {
    data() {
        return {

        }
    },
    methods: {
        innerHTML: innerHTML,
        success(message) {
            Message({
                message
            })
        },
        error(message) {
            Message({
                message: message,
                duration: 30 * 1000,
                forbidClick: true,
                showClose: true
            })
        }
    }
}

export {
    mixins
}